import React from 'react';

import Plasticsprayer from './Plasticsprayer';
import Sprayermakings from './Sprayermakings';
import Backpacksprayer from './Backpacksprayer';

const Plasticbackspray = () => {
    return (
        <div>
            <Plasticsprayer />
            <Sprayermakings />
            <Backpacksprayer />
        </div>
    );
};

export default Plasticbackspray;
